// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"159106e0","440":"7a1ea762","551":"7e0ef9b1"}[chunkId] + ".chunk.js";
};